import gql from 'graphql-tag';

import {Address} from './address.fragment';

export const InstitutionDetails = gql`
    fragment InstitutionDetails on InstitutionDetails {
        email
        phone
        vat
        ean
        description
        address {
            ...Address
        }
    }
    ${Address}
`;
